import { useMemo } from "react";

import { useLoopscaleWalletContext } from "@bridgesplit/abf-react";

import { WalletConnectError } from "./type";

export function useConnectingWalletErrors() {
    const { data: loopscaleWalletData, isLoading } = useLoopscaleWalletContext();
    const pubkey = loopscaleWalletData?.userPublicKey;

    const error: WalletConnectError = useMemo(() => {
        if (isLoading) return WalletConnectError.None;
        if (!pubkey) return WalletConnectError.NotConnected;

        return WalletConnectError.None;
    }, [isLoading, pubkey]);

    return { error, isLoading };
}
